export default __webpack_public_path__ + "static/img2-e1fec061a480fa99686366b4e6b0217c.jpg";